module.exports = __webpack_public_path__ + "img/primary-cube.de63d9d1.svg";